import { ref, update } from "firebase/database";
import { listenDatabaseValue as onValue } from "../../utils/listenDatabaseValue";
import { db } from "../../lib/firebase";

export const NEW_FEATURES_SEEN_ROOT = "newFeaturesSeen";

/**
 * @param {string | null | undefined} uid
 * @returns {string | null}
 */
export const getNewFeaturesSeenPath = (uid) =>
  uid ? `${NEW_FEATURES_SEEN_ROOT}/${uid}` : null;

/**
 * @param {string | null | undefined} uid
 * @param {string | null | undefined} featureId
 * @returns {string | null}
 */
export const getNewFeatureSeenPath = (uid, featureId) =>
  uid && featureId ? `${NEW_FEATURES_SEEN_ROOT}/${uid}/${featureId}` : null;

/**
 * @param {string | null | undefined} featureId
 * @param {Record<string, boolean | null | undefined>} [seenById]
 * @returns {boolean}
 */
export const isFeatureSeen = (featureId, seenById = {}) =>
  Boolean(seenById?.[featureId]);

/**
 * @param {string | null | undefined} uid
 * @param {(seenById: Record<string, boolean>) => void} onData
 * @param {(error: Error) => void} [onError]
 * @returns {() => void}
 */
export const subscribeNewFeaturesSeen = (uid, onData, onError) => {
  const path = getNewFeaturesSeenPath(uid);

  if (!path) {
    onData({});
    return () => {};
  }

  const dbRef = ref(db, path);

  return onValue(
    dbRef,
    (snapshot) => {
      onData(snapshot.val() || {});
    },
    (error) => {
      onData({});
      onError?.(error);
    }
  );
};

/**
 * @param {string | null | undefined} uid
 * @param {string} featureId
 * @returns {Promise<boolean>}
 */
export const writeNewFeatureSeen = async (uid, featureId) => {
  const path = getNewFeatureSeenPath(uid, featureId);

  if (!path) {
    return false;
  }

  await update(ref(db), {
    [path]: true,
  });

  return true;
};
